/** @file mirrorStart: the first frame of a mirrorHalf clip's mirrored (computed) half, or null. */
import type { Clip } from '@zilo/pose3d-format/types/clip';

/**
 * `loopStart + floor((frames - loopStart) / 2)` when `mirrorHalf` is set and the loop is longer than one frame (the
 * runtime's rule: frames at or after it play the first half's twin pose); null otherwise.
 */
export function mirrorStart(clip: Pick<Clip, 'mirrorHalf' | 'frames' | 'loopStart'>): number | null {
  const loopLen = clip.frames - clip.loopStart;
  return clip.mirrorHalf && loopLen > 1 ? clip.loopStart + Math.floor(loopLen / 2) : null;
}
